<div class="order-item-options" woa-responsive>
    @if (canShowSizes()) {
        <div class="order-item-options-sizes">
            <div class="order-item-options-sizes-header">
                {{ sizesTitle() | translate: {size: menuItemSizes()[0].sellableSize.externalSizeName} }}
            </div>
            <div class="order-item-options-sizes-options">
                @for (size of menuItemSizes(); track size; let i = $index) {
                    <woa-order-item-option-control id="size-{{i}}"
                                                   class="order-item-options-sizes-options-size"
                                                   [title]="size.sellableSize.sizeLabel"
                                                   [price]="getSizePrice(size)"
                                                   [guestPrice]="getSizeGuestPrice(size)"
                                                   [showPriceSign]="OrderModel.SHOW_RELATIVE_PRICING_FOR_SIZES"
                                                   [showImage]="false"
                                                   [outOfStock]="menuModel.itemOutOfStock()(size.menuItem)"
                                                   [atLimit]="orderModel.menuItemAtLimit()(size.menuItem, size.menuItem.sellable.minWebOrderQty)"
                                                   [selected]="size === selectedSize()"
                                                   (onSelect)="selectSize(size)"></woa-order-item-option-control>
                }
            </div>
        </div>
    }
    @if (showOptions()) {
        @if (!isCompositeItem()) {
            <div class="order-item-options-simple">
                @if (configurationModel.app()?.showTotalIncludedExtras && (orderItem().totalIncludedMultiSelectExtras() > 0 || orderItem().totalIncludedSingleSelectExtras() > 0)) {
                    <div class="order-item-options-simple-inclusions">
                        <div class="order-item-options-simple-inclusions-label">
                            {{ 'woa.label.extras.totalIncluded' | translate }}:
                        </div>
                        <div class="order-item-options-simple-inclusions-amount">
                            {{ (orderItem().totalIncludedMultiSelectExtras() + orderItem().totalIncludedSingleSelectExtras()) | woaCurrency }}
                        </div>
                    </div>
                }
                <woa-order-item-extras-edit-panel [orderItem]="orderItem()" [mainOrderItem]="orderItem()"
                                                  [originalOrderItem]="originalOrderItem()"
                                                  [menuItem]="orderItem().menuItem()"
                                                  [minimalMode]="minimalMode"
                                                  (onChange)="extraChanged($event)"></woa-order-item-extras-edit-panel>
            </div>
        }
        @if (isCompositeItem()) {
            @for (item of orderCompositeItem()!.compositeComponentsSignal(); track item) {
                @if (showCompositeItem(item)) {
                    <div class="order-item-options-composite" woa-responsive
                         [ngClass]="{
                             'plg': isOrderPlgItem(item),
                             'error': orderModel.addToOrderAttempted() && item.validationMessage()
                         }">
                        <div class="order-item-options-composite-header" woa-activatable
                             (onActivate)="selectPlgSellable(asOrderPlgItem(item),undefined)">
                            <div class="order-item-options-composite-header-indicator"
                                 [ngClass]="{'complete': item.isComplete()}">
                            </div>
                            @if (isOrderPlgItem(item)) {
                                <div class="order-item-options-composite-header-label">
                                    {{ 'woa.heading.order.plg.choose' | translate: {plgName: plgName(item)} }}
                                </div>
                            }
                            @if (!isOrderPlgItem(item)) {
                                <div class="order-item-options-composite-header-label">
                                    {{ item.compositeItemName() }}
                                </div>
                            }
                        </div>
                        @if (showSinglePlgItem() && item.sellable() == undefined) {
                            <div class="order-item-options-composite-unselected" woa-activatable
                                (onActivate)="selectPlgSellable(asOrderPlgItem(item),undefined)">
                                <woa-button [tier]="ButtonTier.SECOND" [prominence]="ButtonProminence.LOW"
                                            [label]="'woa.button.order.selectPlg'"
                                            (onActivate)="selectPlgSellable(asOrderPlgItem(item))"></woa-button>
                            </div>
                        }
                        @if ((showSinglePlgItem() || !isOrderPlgItem(item)) && item.sellable() != undefined) {
                            <div class="order-item-options-composite-selected">
                                @if (menuModel.getMenuItemProductImage(item.menuItem())) {
                                    <div class="order-item-options-composite-selected-image">
                                        <img class="order-item-options-composite-selected-image-object" alt=""
                                             [woa-image-cache]="menuModel.standardItemImage()(item.menuItem())"
                                             woa-activatable
                                             (onActivate)="selectPlgSellable(asOrderPlgItem(item),undefined)">
                                    </div>
                                }
                                <div class="order-item-options-composite-selected-details">
                                    @if (showSinglePlgItem() && isOrderPlgItem(item)) {
                                        <div class="order-item-options-composite-selected-details-heading">
                                            <div class="order-item-options-composite-selected-details-heading-label">
                                                {{ item.nameSignal() }}
                                            </div>
                                            <woa-link class="order-item-options-composite-selected-details-heading-change"
                                                      id="change-plg-link" [link]="'woa.button.order.changePlg'"
                                                      (onActivate)="selectPlgSellable(asOrderPlgItem(item),undefined)"></woa-link>
                                        </div>
                                    }
                                    @if (menuModel.getSellableExternalDescription(item.sellable())) {
                                        <div class="order-item-options-composite-selected-details-description"
                                            [innerHtml]="menuModel.getSellableExternalDescription(item.sellable()) | html"></div>
                                    }
                                    <woa-dietary-panel class="order-item-options-composite-selected-details-dietary"
                                                       [sellable]="item.sellable()"></woa-dietary-panel>
                                </div>
                            </div>
                        }
                        @if (!showSinglePlgItem() && isOrderPlgItem(item)) {
                            <div class="order-item-options-composite-plg-options">
                                @for (plgSellable of availablePlgSellables().get(item.identifier); track plgSellable; let i = $index) {
                                    <woa-order-item-option-control id="plg-{{i}}"
                                                                   class="order-item-options-composite-plg-options-option"
                                                                   woa-responsive
                                                                   [layout]="OrderItemOptionLayout.VERTICAL"
                                                                   [image]="menuModel.getMenuItemProductImage(plgSellable.menuItem)"
                                                                   [title]="menuModel.getMenuItemDisplayName(plgSellable.menuItem) || plgSellable.sellable.name"
                                                                   [price]="plgSellable.additionalPrice"
                                                                   [showImage]="plgHasImages().get(item.identifier)"
                                                                   [unavailable]="plgSellableAtLimit()(plgSellable) && !asOrderPlgItem(item).matchesSellable()(plgSellable)"
                                                                   [selected]="asOrderPlgItem(item).matchesSellable()(plgSellable)"
                                                                   (onSelect)="selectPlgSellable(asOrderPlgItem(item), plgSellable)">
                                        <woa-dietary-panel [sellable]="plgSellable.sellable"></woa-dietary-panel>
                                    </woa-order-item-option-control>
                                }
                            </div>
                        }
                        @if (item.sellable() != undefined) {
                            <div class="order-item-options-composite-extras">
                                @if (configurationModel.app()?.showTotalIncludedExtras && (item.totalIncludedMultiSelectExtras() > 0 || item.totalIncludedSingleSelectExtras() > 0)) {
                                    <div class="order-item-options-composite-extras-inclusions"
                                         [ngClass]="{minimal: minimalMode}">
                                        <div class="order-item-options-composite-extras-inclusions-label">
                                            {{ 'woa.label.extras.totalIncluded' | translate }}:
                                        </div>
                                        <div class="order-item-options-composite-extras-inclusions-amount">
                                            {{ (item.totalIncludedMultiSelectExtras() + item.totalIncludedSingleSelectExtras()) | woaCurrency }}
                                        </div>
                                    </div>
                                }
                                <woa-order-item-extras-edit-panel [orderItem]="item" [mainOrderItem]="orderItem()"
                                                                  [originalOrderItem]="originalOrderItem()"
                                                                  [menuItem]="orderCompositeItem()!.menuItem()"
                                                                  [compositeItem]="true"
                                                                  [minimalMode]="responsiveService.mobile() && !item.sellable().decomposedProductLine"
                                                                  (onChange)="extraChanged($event)"></woa-order-item-extras-edit-panel>
                            </div>
                        }
                    </div>
                }
            }
        }
    }
</div>
